import { z } from 'zod'
import { budgetMinutes, projectId } from './project'

export const taskId = z.string().min(1)
const taskName = z.string().trim().min(1).max(120)

export const createTaskInput = z.object({
  projectId,
  name: taskName,
  budgetMinutes: budgetMinutes.optional()
})
export type CreateTaskInput = z.infer<typeof createTaskInput>

export const updateTaskInput = z
  .object({
    name: taskName.optional(),
    budgetMinutes: budgetMinutes.optional(),
    active: z.boolean().optional()
  })
  .refine((input) => Object.keys(input).length > 0, {
    message: 'Provide at least one task field to update.'
  })
export type UpdateTaskInput = z.infer<typeof updateTaskInput>

export const task = z.object({
  id: taskId,
  budgetMinutes,
  projectId,
  name: z.string().min(1),
  active: z.boolean()
})
export type Task = z.infer<typeof task>
